import * as Yup from 'yup';

export const trimObjectStrings = (obj: any) => {
  const trimmed: any = {};

  Object.entries(obj).forEach(([key, value]) => {
    if (typeof value === 'string') {
      trimmed[key] = value.trim();
    } else {
      trimmed[key] = value;
    }
  });

  return trimmed;
};

export const speakerValidationSchema = Yup.object({
  firstName: Yup.string()
    .trim()
    .min(3, 'Minimum 3 characters')
    .max(100, 'First name cannot exceed 100 characters')
    .required('First Name is required'),
  lastName: Yup.string()
    .trim()
    .min(3, 'Minimum 3 characters')
    .max(100, 'Last name cannot exceed 100 characters')
    .required('Last name is required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
  phone: Yup.string().matches(
    /^[0-9]{9,15}$/,
    'Phone number must be 9–15 digits'
  ),
  designation: Yup.string()
    .trim()
    .max(100, 'Designation cannot exceed 100 characters'),
  organization: Yup.string()
    .trim()
    .max(250, 'Organization Name cannot exceed 250 characters'),
  bio: Yup.string().max(500, 'Bio cannot exceed 500 characters'),
  linkedinUrl: Yup.string().url('Invalid URL'),
  twitterUrl: Yup.string().url('Invalid URL'),
  websiteUrl: Yup.string().url('Invalid URL'),
  // yearsOfExperience: Yup.number()
  //   .min(1, 'Years Of Experience must be greater than 0')
  //   .max(99, 'Years Of Experience must be less than 100'),
  yearsOfExperience: Yup.number()
    .transform((value, originalValue) =>
      originalValue === '' ? undefined : value
    )
    .nullable()
    .notRequired()
    .min(1, 'Years Of Experience must be greater than 0'),
  expertiseAreas: Yup.array().of(Yup.string()).nullable(),
  speakingTopics: Yup.array().of(Yup.string()).nullable(),
  specialRequirements: Yup.string().nullable(),
  isActive: Yup.boolean(),
});

export type SpeakerFormValues = Yup.InferType<typeof speakerValidationSchema>;
